import { TRANSLATIONS } from "@/i18n";
import { GlobalCounter } from "@/components/diplomate/GlobalCounter";
import { BureaucraticMachine } from "@/components/diplomate/BureaucraticMachine";

export const HeroSection = ({ lang }) => {
  const t = TRANSLATIONS[lang];
  return (
    <section
      className="relative z-10 max-w-7xl mx-auto px-4 sm:px-8 pt-10 sm:pt-16 pb-8 sm:pb-12"
      data-testid="hero-section"
    >
      <div className="grid md:grid-cols-[1.55fr_1fr] gap-10 md:gap-12 items-start">
        <div className="animate-slide-up">
          <div className="flex items-center gap-3 mb-6 sm:mb-8">
            <span className="dossier-tag">{t.heroKicker}</span>
            <span className="flex-1 h-px bg-black/20 max-w-[160px]" />
            <span className="dossier-tag">{t.dossierRef}</span>
          </div>
          <h2
            className="hero-title text-black text-[42px] sm:text-[62px] lg:text-[76px]"
            data-testid="hero-title"
          >
            <span className="block">{t.heroTitleLine1}</span>
            <span className="block italic font-semibold text-[#2A4A3E]">
              {t.heroTitleLine2}
            </span>
          </h2>
          <p
            className="mt-6 sm:mt-8 text-base sm:text-lg text-[#4A4A4A] leading-[1.6] max-w-[520px] font-normal"
            data-testid="hero-sub"
          >
            {t.heroSub}
          </p>
          <GlobalCounter lang={lang} />
        </div>

        {/* Editorial floating illustration — no card, no border, just the SVG */}
        <div className="hidden md:block relative">
          <div className="flex items-center gap-3 mb-4">
            <span className="dossier-tag">Schéma · Fig. 01</span>
            <span className="flex-1 h-px bg-black/15" />
          </div>
          <BureaucraticMachine className="w-full h-auto max-w-[420px] ml-auto" />
        </div>
      </div>

      {/* Mobile: compact machine below the title */}
      <div className="md:hidden mt-10 relative">
        <div className="flex items-center gap-3 mb-3">
          <span className="dossier-tag">Schéma · Fig. 01</span>
          <span className="flex-1 h-px bg-black/15" />
        </div>
        <BureaucraticMachine className="w-full h-auto max-w-[300px] mx-auto" />
      </div>
    </section>
  );
};
